interface Props {
  currency: CurrencyUnit;
}

export const CurrencyAdorment = ({ currency }: Props) => {
  return <span style={{ color: 'gray' }}>{`(${currency})`}</span>;
};
